// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ff92fb06","498":"406de6d5","703":"1457d21b","787":"92150995"}[chunkId] + ".chunk.js";
};